import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import ScrollProgress from "./components/feature/ScrollProgress";

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <ScrollProgress />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;